import React from "react";
import { IoLogoDesignernews } from "react-icons/io";
import styled from "styled-components";

import LogoPic from "./ASSESTS/AndelaLogo.svg";

import { CiFacebook } from "react-icons/ci";
import { BsTwitter } from "react-icons/bs";
import { BsGithub } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";
import { AiFillYoutube } from "react-icons/ai";
import { BsLinkedin } from "react-icons/bs";

const Footer = () => {
  return (
    <div>
      <Container>
        <Wrapper>
          <Div1>
            <Logo src={LogoPic} />
            <IconHold>
              <CiFacebook />
              <BsTwitter />
              <BsGithub />
              <BsInstagram />
              <AiFillYoutube />
              <BsLinkedin />
            </IconHold>
          </Div1>
          <Div2>
            <One>
              <h4>Discover Talent</h4>

              <Nav>For Companies</Nav>
              <Nav>Enterprise</Nav>
              <Nav> Case studies</Nav>
              <Nav></Nav>
            </One>
            <Two>
              <h4>Find Work</h4>
              <Nav>For Technologists</Nav>
              <Nav>Learning Community</Nav>
              <Nav>Leadership Program</Nav>
              <Nav>Resources</Nav>
            </Two>
            <Three>
              <h4>Andela</h4>
              <Nav>About us</Nav>
              <Nav>Events</Nav>
              <Nav>Blog</Nav>
              <Nav>Press Center</Nav>
              <Nav>Careers</Nav>
            </Three>
            <Four>
              <h4></h4>
              <Nav>Privacy Policy</Nav>
              <Nav>Terms and Conditions</Nav>
              <Nav>Modern Slavery Statement</Nav>
              <Nav></Nav>
            </Four>
          </Div2>
        </Wrapper>
      </Container>
    </div>
  );
};

export default Footer;

const Wrapper = styled.div`
  width: 90%;
  height: 200px;
  display: flex;
  padding-bottom: 20px;
`;

const Nav = styled.div`
  line-height: 40px;
  cursor: pointer;
  font-size: 15px;
  :hover {
    text-decoration: underline;
  }
`;

const One = styled.div`
  width: 20%;
  height: 100%;
  color: white;
  /* background-color: orange; */
`;

const Two = styled.div`
  width: 20%;
  height: 100%;
  color: white;
  /* background-color: aqua; */
`;

const Three = styled.div`
  width: 20%;
  height: 100%;
  color: white;
  /* background-color: orchid; */
`;

const Four = styled.div`
  width: 20%;
  height: 100%;
  color: white;
  /* background-color: olivedrab; */
`;

const Logo = styled.img`
  margin-top: 30px;
  width: 250px;
  height: 60px;
`;

const IconHold = styled.div`
  margin-top: 50px;
  width: 250px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  color: white;
  /* background-color: paleturquoise; */

  font-size: 25px;
`;

const Div1 = styled.div`
  width: 30%;
  height: 100%;

  /* background-color: purple; */
`;

const Div2 = styled.div`
  width: 70%;
  height: 100%;
  /* background-color: pink; */

  display: flex;
  justify-content: space-between;
`;

const Container = styled.div`
  width: 100%;
  height: 250px;
  background-color: #173b3f;

  display: flex;
  justify-content: center;
  align-items: center;
`;
